{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              32.45880437429949,
              30.08832516473653
            ],
            [
              32.073135564127256,
              29.435141244989012
            ],
            [
              35.013427184260195,
              23.510561564081243
            ],
            [
              36.8526276594103,
              21.310385499620665
            ],
            [
              37.112475521194824,
              18.88945999349764
            ],
            [
              37.69132218287419,
              18.148445269309278
            ],
            [
              39.6644317523548,
              14.903328285661587
            ],
            [
              42.86427500718577,
              12.528106232376771
            ],
            [
              43.747624219869465,
              12.751004479414604
            ],
            [
              42.81951158117843,
              17.40663943116263
            ],
            [
              39.63825149648852,
              22.190976207169925
            ],
            [
              37.956082798412154,
              25.3512224796453
            ],
            [
              34.950531768300465,
              29.553329793709224
            ],
            [
              32.45880437429949,
              30.08832516473653
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}